var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.5,
    height: 17.5,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fb",
    transform: "translate(-363 -136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_413",
    "data-name": "Rectangle 413",
    transform: "translate(363 136)",
    fill: "#569dfa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22 23.5 L 8 23.5 C 3.864490032196045 23.5 0.5 20.1355094909668 0.5 16 L 0.5 8 C 0.5 3.864490032196045 3.864490032196045 0.5 8 0.5 L 22 0.5 C 26.1355094909668 0.5 29.5 3.864490032196045 29.5 8 L 29.5 16 C 29.5 20.1355094909668 26.1355094909668 23.5 22 23.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8 1 C 4.140190124511719 1 1 4.140190124511719 1 8 L 1 16 C 1 19.85980987548828 4.140190124511719 23 8 23 L 22 23 C 25.85980987548828 23 29 19.85980987548828 29 16 L 29 8 C 29 4.140190124511719 25.85980987548828 1 22 1 L 8 1 M 8 0 L 22 0 C 26.41827964782715 0 30 3.581720352172852 30 8 L 30 16 C 30 20.41827964782715 26.41827964782715 24 22 24 L 8 24 C 3.581720352172852 24 0 20.41827964782715 0 16 L 0 8 C 0 3.581720352172852 3.581720352172852 0 8 0 Z",
    stroke: "none",
    fill: "#5aa2fb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_104498_facebook_icon",
    "data-name": "104498_facebook_icon",
    d: "M27.043,12.41H23.957V10.386a.824.824,0,0,1,.859-.937h2.178V6.108l-3-.012a3.8,3.8,0,0,0-4.087,4.087V12.41H17.982v3.443h1.925V25.6h4.05V15.853H26.69Z",
    transform: "translate(355.488 132.904)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.d1467070bceec690db0132cc5f4a5d14.svg";
export { ForwardRef as ReactComponent };